import React from 'react'

import DropFilePanel from './panels/DropFilePanel'
import ImportStatusPanel from './panels/ImportStatusPanel'

const PanelsControl = ({ entity }) => {
  const [importId, setImportId] = React.useState()
  if (!importId) return <DropFilePanel onStartImport={({ id }) => setImportId(id)} entity={entity} />
  return <ImportStatusPanel importId={importId} onRestartImporter={() => setImportId(null)} />
}

export default PanelsControl
